<div class="users-in-view">
  <ng-container *ngFor="let user of usersInView">
    <div class="user-in-view" matTooltip="{{user.name}}"
    matTooltipClass="home365-black-tooltip" matTooltipPosition="above">
      <img *ngIf="user.profileImg" (click)="selectUserInView(user)" class="home365-profile-image"
           [src]="user.profileImg" alt="" [ngClass]="{'selected': user.selected}">
      <span *ngIf="!user.profileImg" (click)="selectUserInView(user)" class="home365-profile-image no-image"
            [ngClass]="{'selected': user.selected}">{{getInitials(user)}}</span>
    </div>
  </ng-container>
  <div class="home365-profile-image no-image remain-users selected" *ngIf="usersList.length > maxUsersInView"
       (click)=select.open()>
    <p>+{{usersList.length - usersInView.length}}</p>
  </div>
</div>

<mat-select
  [formControl]="control"
  #select multiple
  class="langSelect">
  <mat-option *ngFor="let usr of usersList" [value]="usr.id" (onSelectionChange)="usrSelection($event)">
    <div class="option-content">
      <img *ngIf="usr.profileImg" [src]="usr.profileImg" class="home365-profile-image in-mat-option">
      <span *ngIf="!usr.profileImg"  class="home365-profile-image no-image in-mat-option">{{getInitials(usr)}}</span>
      <p class="bolder user-name">{{usr.name}}</p>
    </div>

  </mat-option>
</mat-select>

